import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import {
  ProductDetailsBiDownload,
  ProductDetailsBiDownloadVariables
} from "./types/ProductDetailsBiDownload";
import {
  ProductDetailsBiList,
  ProductDetailsBiListVariables
} from "./types/ProductDetailsBiList";

export const productDetailsBiList = gql`
  ${pageInfoFragment}
  query ProductDetailsBiList(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: ProductDetailsFilterInput!
  ) {
    productDetails(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          product_name
          product_status
          updated_at
        }
      }
    }
  }
`;

export const useProductDetailsBiListQuery = makeBossQuery<
  ProductDetailsBiList,
  ProductDetailsBiListVariables
>(productDetailsBiList);

export const productDetailsBiDownload = gql`
  ${pageInfoFragment}
  query ProductDetailsBiDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: ProductDetailsFilterInput!
  ) {
    productDetails(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          product_name
          product_status
          updated_at
          category_code
          category_name
        }
      }
    }
  }
`;

export const useProductDetailsBiDownloadQuery = makeBossQuery<
  ProductDetailsBiDownload,
  ProductDetailsBiDownloadVariables
>(productDetailsBiDownload);
